import { Link } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';

export function NotFound() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  return (
    <div className="text-center py-12">
      <h1 className="text-6xl font-bold text-gray-900 mb-4">404</h1>
      <h2 className="text-2xl font-semibold text-gray-700 mb-4">Page Not Found</h2>
      <p className="text-gray-600 mb-8">
        The page you're looking for doesn't exist.
      </p>
      <Link
        to={isAuthenticated ? '/dashboard' : '/'}
        reloadDocument={!isAuthenticated}
        className="bg-blue-700 text-white px-6 py-3 rounded-lg hover:bg-blue-800 transition-colors"
      >
        Go Home
      </Link>
    </div>
  );
}